// Google Analytics 4 — caricato SOLO dopo consenso esplicito (cookie banner).
// Configurare REACT_APP_GA_MEASUREMENT_ID in frontend/.env per attivarlo.
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let loaded = false;

export function loadAnalytics() {
  if (loaded || !GA_MEASUREMENT_ID) return;
  loaded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!window.gtag || !GA_MEASUREMENT_ID) return;
  window.gtag("event", "page_view", { page_path: path, page_title: document.title });
}

export function trackEvent(name, params = {}) {
  if (!window.gtag) return;
  window.gtag("event", name, params);
}
